import React from 'react';
import Typography from '@mui/material/Typography';

const LegendText = ({ text, marginTop = 1 }) => {
    return (
        <Typography sx={{
            fontFamily: "Open Sans, sans-serif",
            fontWeight: "bold",
            fontSize: "18px",
            color: "#2c5a82",
            marginTop: marginTop,
            marginBottom: 1,
            marginLeft: "12px"
        }}>
            {text}
        </Typography>
    );
}

export default LegendText;